// Admin gate — Phase 1 role check.
// Renders children only if the current session has an admin_users row.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../lib/useSession';
import { AppShell } from './AppShell';

export function AdminGate({ children }) {
  const { user, isAdmin, loading, configured } = useSession();

  if (!configured) {
    return (
      <AppShell>
        <div className="wizard-card">
          <div className="eyebrow">Admin</div>
          <h1 className="h2 mt-3">Admin is offline</h1>
          <p className="mt-4" style={{ color: 'var(--text-dim)' }}>
            Supabase is not configured yet. Add
            <code className="mx-1">REACT_APP_SUPABASE_URL</code>
            and
            <code className="mx-1">REACT_APP_SUPABASE_ANON_KEY</code>
            to <code>/app/frontend/.env</code> to enable the admin.
          </p>
        </div>
      </AppShell>
    );
  }

  if (loading) {
    return (
      <AppShell>
        <div className="wizard-card">
          <div className="eyebrow">Admin</div>
          <p className="mt-4">Checking access…</p>
        </div>
      </AppShell>
    );
  }

  if (!user) return <Navigate to="/sign-in" replace />;

  if (!isAdmin) {
    return (
      <AppShell>
        <div className="wizard-card">
          <div className="eyebrow" style={{ color: 'var(--error)' }}>
            Access denied
          </div>
          <h1 className="h2 mt-3">You don&apos;t have admin access</h1>
          <p className="mt-4" style={{ color: 'var(--text-dim)' }}>
            Ask an existing admin to add your account to{' '}
            <code>admin_users</code>.
          </p>
        </div>
      </AppShell>
    );
  }

  return <>{children}</>;
}

export default AdminGate;
